<template>
    <div >
      <img class="topimg" src="../assets/newimg/images/logo_03_03.png">
      <form>
        <div class="input-control">
          <input placeholder="输入设备号" v-model="iccid" />
          <img class="addon" v-if="wxReady" @click="handleScan" src="../assets/images/scan.png">
        </div>
        <template v-if="cardCheckOK==true && needAuth == 1 && binded==false">
          <!--<div class="input-control">
            <input v-model="ruleForm.name" placeholder="使用人姓名" />
          </div>-->
          <div class="input-control">
            <input v-model="ruleForm.mobile" placeholder="输入手机号" />
            <span class="smscode" @click="handleSms">{{smsBtnTxt}}</span>
          </div>

          <div class="input-control">
            <input v-model="ruleForm.code"  placeholder="输入验证码" />
          </div>
        </template>

        <template v-else-if="binded==true && needAuth ==1 ">
          <!--<div class="input-control">
            <input v-model="bindInfo.username" disabled placeholder="使用人姓名" />
          </div>-->
          <div class="input-control">
            <input v-model="bindInfo.mobile" disabled placeholder="输入手机号" />
          </div>
          <div style="font-size: .24rem;color: #000;">以上信息为此号码当前绑定的使用人信息，如有疑问，请联系客服</div>
        </template>
          <div class="btn" @click="handleCheckCard" v-if="cardCheckOK==false">查询</div>
          <div class="btn" @click="handleBindCard" v-else-if="binded==false">绑定</div>
          <div class="btn" @click="handleQueryCard" v-else-if="binded==true">确认</div>
      </form>
      <div class="tips">
        <div class="title">温馨提示：</div>
        <div>1：卡号为卡芯后的数字，短号为设备背面的字母和数字</div>
        <div>2：因产品实名使用之后，无法二次销售，故无法退卡</div>
        <div>3：绑卡时请核实该地区是否能使用，谨慎操作</div>
        <div>4：新疆、西藏、云南、港澳台不可使用!</div>
      </div>
    </div>
</template>
<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "bind",
        data() {
            return {
                iccid: '',
                cardLengthCheck:false,
                errMsg: false,
                cardCheckOK:false,
                wxReady:false,
                sms:false,
                binded:false,
                bindInfo:{},
                needAuth:0,
                token:'',
              showList:false,
                cardlist:[],
                smsBtnTxt:'发送验证码',
                ruleForm:{
                    iccid:'',
                    mobile:'',
                    name:'',
                    code:''
                }
            };
        },
        watch:{
            iccid(iccid){
                this.iccid = iccid.toUpperCase();
                this.cardCheckOK = false;
                this.needAuth = 0;
                this.binded = false
                if(this.iccid.indexOf('C') !== -1){
                    //移动卡二十位
                    if(this.iccid.length == 20 || (this.iccid.length >= 6 && this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }else{
                    if(this.iccid.length == 19  || (this.iccid.length >= 6 || this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }
            }
        },
      methods: {
            handleCheckCard(){
                this.errMsg = '';
                this.cardCheckOK = false;
                this.binded = false;
                this.$toast.loading('查询中');
                localStorage.setItem("iccid",this.iccid)
                this.fetchData('/card/queryCard',{iccid:this.iccid},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.cardCheckOK = true
                        this.needAuth = res.data.needAuth
                        if(this.needAuth == 0) {
                            this.$router.push({name: 'index'})
                        }else if(res.data.mobile){
                            /*this.binded = true
                            this.bindInfo = res.data*/
                          this.handleQueryCard()
                        }
                    }else{
                      if(res.url){
                        window.location.href = res.url
                        return;
                      }
                      this.$notify(res.msg);
                        this.errMsg = res.msg
                    }
                })
            },
            handleQueryCard(){
                this.$router.push({name:'index',query:{iccid:this.iccid}})
            },
            handleBindCard(){
                this.$toast.loading('绑定中')
                this.ruleForm.iccid = this.iccid
                this.fetchDataPost('/card/bind',this.ruleForm,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg);
                        this.$router.push({name:'index'})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScan(){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success:(res)=>{
                        if(res.resultStr.includes(',')){
                            this.iccid = res.resultStr.split(',')[1];
                        }else {
                            this.iccid = res.resultStr;
                        }

                    }
                })
            },
            getCardListByOpenid(openid){
              this.fetchData('/card/querylist', {}, (res) => {
                console.log(res)
                if (res.code) {
                  for (var i in res.data) {
                    let card = res.data[i];
                    this.cardlist.push({
                      name: card.iccid,
                      value: card.iccid
                    })
                    if (card.default == 1) {
                      this.iccid = card.iccid;
                    }
                  }
                  if(!this.iccid && res.data && res.data[0]){
                    this.iccid = res.data[0].iccid
                  }
                }
              })
            },
            handleSms(){
                if(this.sms == false) {
                    this.sms = true
                    this.$toast.loading()
                    this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success('发送成功')
                            let s = 60;
                            let intval = setInterval(()=>{
                                this.smsBtnTxt = s+'秒重发'
                                if(s <= 0){
                                    this.smsBtnTxt = '发送验证码';
                                    this.sms = false;
                                    clearInterval(intval);
                                }
                                s--;
                            },1000)

                        } else {
                            this.sms = false;
                            this.$toast.fail('发送失败')
                        }
                    })
                }
            },
        },
        created: function () {
            this.initWechatJs()
            if(this.$route.query.cardno){
                this.iccid = this.$route.query.cardno
            }else if(!this.$route.query.nostorage){
              this.iccid = localStorage.getItem("iccid");
            }
            if(this.iccid){
              if(this.$route.query.auto) {
                this.handleCheckCard()
              }
            }else if(!this.$route.query.nostorage){
              let openid = sessionStorage.getItem('token')
              if(!openid && this.$route.query.appid){
                this.$router.push({name: 'login',query:{appid:this.$route.query.appid,path:'/'}})
              }else if(openid){
                this.getCardListByOpenid(openid)
              }
            }

        }
    };
</script>
<style scoped lang="scss">
  .tips{
    .title{
      line-height: 2;
      font-size: .3rem;
    }
    width: 6.2rem;
    margin: 1rem auto 0;
    color: #fff;
    font-size: .25rem;
    line-height: 1.6;
  }
  .topimg {
   width: 5rem;
    display:block;
    margin: 1rem auto;
  }
  form{
    font-size: .34rem;
    display: block;
    width: 6.2rem;
    margin: .2rem auto;
.btn{
  font-size: .36rem;
  width: 2.16rem;
  height: .56rem;
  line-height: .56rem;
  text-align: center;
  background: #28a8fa;
  border-radius: .4rem;
  color: #fff;
  margin: .4rem auto 0;
}
    .input-control{
      position: relative;
      width: 100%;
      height: .76rem;
      line-height: .76rem;
      background: #fff;
      margin-bottom: .6rem;
      input{
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        border: none;
        text-indent: .4rem;
      }
      input[disabled]{
        background: #dfdfdf;
      }
      .addon{
        position: absolute;
        right: .1rem;
        top: .13rem;
        height: .5rem;
        width: .5rem;
      }
      .smscode{
        position: absolute;
        right: .1rem;
        top: .13rem;
        line-height: 1;
        padding: .1rem .2rem;
        border-radius: .2rem;
        color: #fff;
        background: #28a8fa;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/bind.vue